function getMaterialTextControl(name, changeHandler = null) {
    let input = $('#id_' + name);
    initMaterialTextControl(input, changeHandler);
    return input;
}

function initMaterialTextControl(input, changeHandler = null) {
    let isSelect = input.prop('nodeName') === 'SELECT';

    let controlGroup = input.parents('.control-group');
    let inputChangeFn = function () {
        let value = input.val();

        if (isSelect) {
            controlGroup.addClassIf('with-content', value && parseInt(value) > 0);
        } else {
            controlGroup.addClassIf('with-content', value && value.length > 1);
        }
        if (changeHandler) {
            changeHandler();
        }
    }
    input.change(inputChangeFn).click(inputChangeFn).keyup(inputChangeFn);
    inputChangeFn();
}
